export const calculateSum = arr => +(arr.reduce((accumulator, currentValue) => accumulator + currentValue)).toFixed(2)